import {gwtBuildServerCall} from '../_shared/GWTBridge/invoke/server';

/* all messages are processed in gwt;
 * this function deals with two cases:
 * noWarning / Warning approved => resolve
 * warning canceled / Error => reject
 */
export function processServerResponse<T>(
    resolve: (value: T | PromiseLike<T>) => void,
    reject: (reason?: string) => void
) {
    return data => {
        if (!data) {
            reject('no data');
        } else if (data.Canceled) {
            reject('warning rejected');
        } else {
            resolve(data);
        }
    };
}

/** isProcessServerAnswer should be true if we're waiting for some changes to be displayed
 * or actions to be invoked IN THE FORM (processed by GWT now) as a response to the server answer (INCLUDING ERRORS HANDLING!)
 * it is true in all cases for now;
 *
 * TODO:
 * implement message handling on react side (isProcessServerAnswerGWT = false)
 */
export function buildServerCall<T>(
    methodName,
    parameters,
    reason,
    isProcessServerAnswerGWT = true,
    getConnectionHolder,
    processAsDataSet = false,
    showLoader = true
): Promise<T> {
    return new Promise((resolve, reject) => {
        if (gwtBuildServerCall) {
            gwtBuildServerCall(
                methodName,
                parameters,
                reason,
                isProcessServerAnswerGWT,
                processServerResponse(resolve, reject),
                getConnectionHolder,
                processAsDataSet,
                showLoader
            );
        } else {
            reject('buildServerCall is undefined');
        }
    });
}
